module.exports = require('./ConfirmationModalView');
